module.exports = require('./ConfirmationModalView');
